$(document).ready(function () {
  // Header class toggle
  function toggleHeaderClass() {
    if ($(window).scrollTop() > 1) {
      $('.header').addClass('is-active')
    } else {
      $('.header').removeClass('is-active')
    }
  }

  toggleHeaderClass()

  $(window).on('scroll', toggleHeaderClass)

  // Anchor
  $('[data-scroll-to]').on('click', function (event) {
    event.preventDefault()

    const target = $(this).attr('data-scroll-to')
    const headerHeight = $('.header').outerHeight()
    const $targetElement = $(target)

    if ($targetElement.length) {
      $('.btn-burger').removeClass('is-open')
      $('body').removeClass('menu-active')
      $('html').removeClass('is-ovh')

      $('html, body').animate(
        {
          scrollTop: $targetElement.offset().top - headerHeight,
        },
        500
      )
    } else {
      console.error('Target element not found:', target)
    }
  })

  // Burger animation
  $('.btn-burger__wrapper').on('click', function (event) {
    event.stopPropagation()

    $(this).find('.btn-burger').toggleClass('is-open')
    $('body').toggleClass('menu-active')
    $('html').toggleClass('is-ovh')

    return false
  })

  $(document).on('click', function (event) {
    if (
      !$(event.target).closest('.header__menu, .btn-burger__wrapper').length
    ) {
      $('.btn-burger').removeClass('is-open')
      $('body').removeClass('menu-active')
      $('html').removeClass('is-ovh')
    }
  })

  if ($('#map').length) {
    ymaps.ready(function () {
      var myMap = new ymaps.Map('map', {
        center: [55.708879, 37.622626], // Координати адреси
        zoom: 16,
      })

      var myPlacemark = new ymaps.Placemark(
        [55.708879, 37.622626],
        {
          hintContent: 'Офис В-101',
          balloonContent:
            '<strong>Наш офис</strong><br>Москва, Варшавское шоссе, д.1, стр. 17, офис В-101',
        },
        {
          iconLayout: 'default#image',
          iconImageHref: '/images/pin.png', // Посилання на логотип
          iconImageSize: [56, 74], // Розмір іконки
          iconImageOffset: [-25, -50], // Зміщення для правильного відображення
        }
      )

      myMap.geoObjects.add(myPlacemark)
    })
  }

  // Selecting DOM elements
  const contentElements = [...document.querySelectorAll('.programs-item')]
  const totalContentElements = contentElements.length

  // Function to handle scroll-triggered animations
  const scroll = () => {
    // Створюємо загальний контейнер анімації для кращої послідовності
    const container = contentElements[0].parentElement

    contentElements.forEach((el, position) => {
      const visual = el.querySelector('.programs-item__visual')

      // Основна анімація айтемів - прибираємо особливе налаштування для останнього елемента
      gsap
        .timeline({
          scrollTrigger: {
            trigger: el,
            start: 'center center',
            end: '+=100%',
            scrub: true,
            invalidateOnRefresh: true, // Оновлення при зміні розміру вікна
          },
        })
        .to(
          el,
          {
            ease: 'power1.inOut',
            scale: 0.6,
            opacity: 1,
            yPercent: 0, // Однакова поведінка для всіх елементів
          },
          0
        )

      // Рандомна анімація для .programs-item__visual
      gsap.fromTo(
        visual,
        {
          rotate: gsap.utils.random(-15, 15),
          yPercent: gsap.utils.random(-10, 10),
          scale: gsap.utils.random(0.9, 1.1),
        },
        {
          rotate: 0,
          yPercent: 0,
          scale: 1,
          ease: 'power1.out',
          scrollTrigger: {
            trigger: visual,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      )
    })

    // Додаємо окрему анімацію для плавного переходу після останнього елемента
    if (contentElements.length > 0) {
      const lastElement = contentElements[totalContentElements - 1]

      gsap
        .timeline({
          scrollTrigger: {
            trigger: lastElement,
            start: 'center center',
            end: '+=200%', // Даємо більше простору для анімації
            scrub: true,
          },
        })
        .to(lastElement, {
          ease: 'power2.inOut',
          yPercent: 50, // Більш помірне значення
          opacity: 0.7, // Поступове зникнення
          onComplete: () => {
            // Переконуємося, що прокручування продовжується після анімації
            ScrollTrigger.refresh()
          },
        })
    }
  }

  if ($('.programs-item').length) {
    scroll()
  }

  // Mission
  gsap.registerPlugin(ScrollTrigger)

  // document.querySelectorAll('.mission__in').forEach((section) => {
  //   let numbers = section.querySelectorAll('.mission-counter__item')
  //   let items = section.querySelectorAll('.mission-content__item')

  //   gsap.set(numbers, { yPercent: 100, opacity: 0 })
  //   gsap.set(items, { yPercent: 50, opacity: 0 })

  //   let tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: section,
  //       start: 'top center',
  //       end: 'bottom center',
  //       scrub: true,
  //     },
  //   })

  //   numbers.forEach((num, i) => {
  //     tl.to(
  //       num,
  //       {
  //         yPercent: 0,
  //         opacity: 1,
  //         duration: 0.5,
  //       },
  //       i * 0.5
  //     )
  //   })

  //   items.forEach((item, i) => {
  //     tl.to(
  //       item,
  //       {
  //         yPercent: 0,
  //         opacity: 1,
  //         duration: 0.5,
  //       },
  //       i * 0.5
  //     )
  //   })
  // })

  // Education
  if ($(window).width() > 1024) {
    const educationBg = document.querySelector('.education-bg')
    const educationImg = document.querySelector('.education-bg__illustration')
    const educationTitle = document.querySelector('.education__title')
    const educationSubtitle = document.querySelector('.education__subtitle')
    const educationDec1 = document.querySelector('.education__dec--1')
    const educationDec2 = document.querySelector('.education__dec--2')
    const educationFinancing = document.querySelector('.education-financing')

    // Встановлюємо початковий стан елементів (без анімації)
    gsap.set(educationBg, {
      borderRadius: '80rem 80rem 0 0',
      backgroundColor: 'transparent',
      width: '94.5rem',
      left: '50%',
      x: '-50%',
    })

    gsap.set(educationImg, {
      opacity: 1,
    })

    gsap.set(educationTitle, {
      color: '#00AABB',
      fontSize: '16.8rem',
    })

    // Анімація починається тільки після прокрутки і триває довше
    gsap
      .timeline({
        scrollTrigger: {
          trigger: '.education',
          start: 'top top', // починаємо анімацію після прокрутки 200 пікселів від початку секції
          end: 'bottom center', // закінчуємо ближче до кінця секції, розтягуючи анімацію
          scrub: 1, // збільшено для ще більшої плавності
          // markers: true,
          pin: true,
          toggleActions: 'play none none reverse',
          anticipatePin: 1, // для кращої поведінки з прокруткою
        },
      })
      .to(educationBg, {
        borderRadius: 0,
        backgroundColor: '#00AABB',
        width: '100%',
        left: 0,
        x: 0,
        y: '-22rem',
        duration: 2.5, // значно збільшено тривалість
        ease: 'power1.inOut', // більш плавний ease
      })
      .to(
        educationImg,
        {
          opacity: 0,
          duration: 1.8, // збільшено тривалість
          ease: 'power1.inOut',
        },
        0 // запускаємо одночасно з першою анімацією
      )

      .to(
        educationTitle,
        {
          color: '#FFFFFF',
          fontSize: '5.8rem',
          duration: 2, // збільшено тривалість
          ease: 'power1.inOut', // більш плавний ease
        },
        0.3 // невелика затримка для кращого візуального ефекту
      )

      .to(
        educationSubtitle,
        {
          y: '0rem',
          opacity: 1,
          duration: 1.5, // збільшено тривалість
          ease: 'power1.inOut', // більш плавний ease
        },
        0.6 // невелика затримка для кращого візуального ефекту
      )

      .to(
        educationDec1,
        {
          y: '-18rem',
          opacity: 1,
          duration: 1.5,
          ease: 'power1.inOut', // більш плавний ease
        },
        0.6 // невелика затримка для кращого візуального ефекту
      )

      .to(
        educationDec2,
        {
          y: '-40rem',
          opacity: 1,
          duration: 1.5,
          ease: 'power1.inOut', // більш плавний ease
        },
        0.6 // невелика затримка для кращого візуального ефекту
      )

      .to(educationFinancing, {
        backgroundColor: '#00AABB',
        ease: 'power1.inOut',
      })
  }

  if ($(window).width() <= 1024) {
    $('.history__items').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
    })

    $('.values__items').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
    })
  }

  $('.team__items--big').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.team__items--small',
  })

  $('.team__items--small').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.team__items--big',
    dots: false,
    arrows: false,
    // variableWidth: true,
  })

  const textContainer = document.querySelector('.footer-top__title')

  // Дублюємо контент для безперервного ефекту
  textContainer.innerHTML += ' ' + textContainer.innerHTML

  gsap.to(textContainer, {
    x: '-50%',
    duration: 16,
    ease: 'linear',
    repeat: -1,
  })

  // Додамо HTML для лічильника, якщо його ще немає
  if ($('.team-slider__counter').length === 0) {
    $('.team__items--big').append(
      '<div class="team-slider__counter"><span class="team-slider__current">1</span> / <span class="team-slider__total">0</span></div>'
    )
  }

  if ($(window).width() > 1024) {
    const coFinancing = document.querySelector('.co-financing')
    const coFinancingIn = document.querySelector('.co-financing__in')
    const coFinancingHeadline = document.querySelector(
      '.co-financing__headline'
    )
    const coFinancingDescription = document.querySelector(
      '.co-financing__description'
    )
    const coFinancingDec = document.querySelector('.co-financing__dec')
    const coFinancingItems = document.querySelector('.co-financing__items')
    const coFinancingItem = document.querySelectorAll('.co-financing-item')
    const coFinancingItemFirst = document.querySelectorAll(
      '.co-financing-item:first-child'
    )

    const timelineCofinancing = gsap.timeline({
      scrollTrigger: {
        trigger: '.co-financing',
        start: 'top center',
        end: '+=200%', // Чим більше %, тим довше триває анімація при скролі
        scrub: true, // Робить анімацію більш розтягнутою в часі
        // markers: true,
        pin: true, // Закріплює блок на екрані
        pinSpacing: true, // Забезпечує достатньо місця для анімації
      },
    })

    timelineCofinancing
      .to(
        coFinancingHeadline,
        {
          y: 0,
          fontSize: '5.8rem',
          duration: 1.5,
        },
        0
      )
      .to(
        coFinancingDescription,
        {
          y: 0,
          opacity: 1,
          duration: 1.5,
        },
        1.5
      )
      .to(
        coFinancingIn,
        {
          yPercent: '-50',
          duration: 1.5,
        },
        0.5
      )
      .to(coFinancingItems, {
        y: 0,
        opacity: 1,
      })

      // Анімація айтемів (перелистування знизу-вгору)
      .fromTo(
        coFinancingItem,
        {
          y: 100, // Початкова позиція нижче блоку
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          stagger: {
            each: 2, // Додаємо затримку між появою айтемів
            onComplete: function () {
              gsap.to(coFinancingItemFirst, {
                opacity: 0.7,
                duration: 1,
                y: '-1rem',
              })
            },
          },
          duration: 1.5,
          ease: 'power2.out',
        }
      )

      .to(
        coFinancingDec,
        {
          x: '50%',
          opacity: 1,
          duration: 1,
          width: '300vw',
          height: '300vw',
          ease: 'power1.inOut',
        },
        0
      )
  }

  if ($(window).width() > 1024) {
    const research = document.querySelector('.research')
    const researchHeadline = document.querySelector('.research__headline')
    const researchDescription = document.querySelector('.research__description')
    const researchIn = document.querySelector('.research__in')
    const researchContent = document.querySelector('.research__content')
    const researchDec = document.querySelector('.research__dec')
    const researchSlideIllustration = document.querySelector(
      '.research-slide-illustration'
    )
    const researchSlideContent = document.querySelector(
      '.research-slide-content'
    )

    const timelineResearch = gsap.timeline({
      scrollTrigger: {
        trigger: research,
        start: 'top top',
        end: '+=1000',
        pin: true,
        scrub: 1,
        // markers: true,
      },
    })

    timelineResearch
      .fromTo(
        research,
        {
          '--circle-size': '0vw',
          ease: 'power2.inOut',
        },
        {
          '--circle-size': '500vw',
          ease: 'power2.inOut',
        },
        0
      )

      // .to(researchIn, {
      //   y: '50%'
      // }, 0.3)

      .to(
        researchHeadline,
        {
          fontSize: '5.8rem',
        },
        0
      )

      .to(
        researchDescription,
        {
          y: 0,
          opacity: 1,
        },
        0.3
      )

      .to(
        researchSlideIllustration,
        {
          y: 0,
          opacity: 1,
        },
        0.5
      )

      .to(
        researchSlideContent,
        {
          y: 0,
          opacity: 1,
        },
        0.6
      )
  }
  // Transparency
  // Елементи для анімації
  // Education

  if ($(window).width() > 1024) {
    const transparencyBg = document.querySelector('.transparency-bg')
    const transparencyImg = document.querySelector(
      '.transparency-bg__illustration'
    )
    const transparencyTitle = document.querySelector('.transparency__title')
    const transparencySubtitle = document.querySelector(
      '.transparency__subtitle'
    )
    const transparencyDec1 = document.querySelector('.transparency__dec--1')
    const transparencyDec2 = document.querySelector('.transparency__dec--2')
    const transparencyFinancing = document.querySelector(
      '.transparency-financing'
    )

    // Встановлюємо початковий стан елементів (без анімації)
    gsap.set(transparencyBg, {
      borderRadius: '80rem 80rem 0 0',
      backgroundColor: 'transparent',
      width: '94.5rem',
      left: '50%',
      x: '-50%',
    })

    gsap.set(transparencyImg, {
      opacity: 1,
    })

    gsap.set(transparencyTitle, {
      color: '#121212',
      fontSize: '16.8rem',
    })

    // Анімація починається тільки після прокрутки і триває довше
    gsap
      .timeline({
        scrollTrigger: {
          trigger: '.transparency',
          start: 'top top', // починаємо анімацію після прокрутки 200 пікселів від початку секції
          end: 'bottom center', // закінчуємо ближче до кінця секції, розтягуючи анімацію
          scrub: 1, // збільшено для ще більшої плавності
          // markers: true,
          pin: true,
          toggleActions: 'play none none reverse',
          anticipatePin: 1, // для кращої поведінки з прокруткою
        },
      })
      .to(transparencyBg, {
        borderRadius: 0,
        backgroundColor: '#F3F3F3',
        width: '100%',
        left: 0,
        x: 0,
        y: '-22rem',
        duration: 2.5, // значно збільшено тривалість
        ease: 'power1.inOut', // більш плавний ease
      })
      .to(
        transparencyImg,
        {
          opacity: 0,
          duration: 1.8, // збільшено тривалість
          ease: 'power1.inOut',
        },
        0 // запускаємо одночасно з першою анімацією
      )

      .to(
        transparencyTitle,
        {
          color: 'transparent',
          webkitTextStroke: '0px rgb(18, 18, 18)',
          webkitTextFillColor: 'rgb(18, 18, 18)',
          fontSize: '5.8rem',
          duration: 2, // збільшено тривалість
          ease: 'power1.inOut', // більш плавний ease
        },
        0.3 // невелика затримка для кращого візуального ефекту
      )

      .to(
        transparencySubtitle,
        {
          y: '0rem',
          opacity: 1,
          duration: 1.5, // збільшено тривалість
          ease: 'power1.inOut', // більш плавний ease
        },
        0.6 // невелика затримка для кращого візуального ефекту
      )

      .to(
        transparencyDec1,
        {
          y: '-40rem',
          opacity: 1,
          duration: 1.5,
          ease: 'power1.inOut', // більш плавний ease
        },
        0.6 // невелика затримка для кращого візуального ефекту
      )

      .to(
        transparencyDec2,
        {
          y: '0rem',
          opacity: 1,
          duration: 1.5,
          ease: 'power1.inOut', // більш плавний ease
        },
        0.6 // невелика затримка для кращого візуального ефекту
      )

      .to(transparencyFinancing, {
        backgroundColor: '#F3F3F3',
        ease: 'power1.inOut',
      })
  }


  // Ініціалізація лічильника при завантаженні
  // Встановлюємо загальну кількість слайдів
  let totalSlides = $(
    '.team__items--big .slick-slide:not(.slick-cloned)'
  ).length
  $('.team-slider__total').text(totalSlides)

  // Встановлюємо поточний слайд
  let initialSlide =
    $('.team__items--big .slick-current').data('slick-index') + 1
  $('.team-slider__current').text(initialSlide)

  // Оновлюємо лічильник при зміні слайда
  $('.team__items--big').on(
    'afterChange',
    function (event, slick, currentSlide) {
      // Оновлюємо номер поточного слайда (додаємо 1, бо індекси починаються з 0)
      $('.team-slider__current').text(currentSlide + 1)
    }
  )

  // Для існуючого обробника beforeChange не змінюємо нічого
  $('.team__items--small').on(
    'beforeChange',
    function (event, slick, currentSlide, nextSlide) {
      let totalSlides = slick.$slides.length

      // Визначаємо напрямок руху
      let isNext =
        nextSlide > currentSlide ||
        (currentSlide === totalSlides - 1 && nextSlide === 0)

      // Визначаємо, яке зображення показувати у червоному блоці
      let sourceSlideIndex

      if (isNext) {
        // При русі вперед показуємо ПОПЕРЕДНІЙ від нового центрального
        sourceSlideIndex = (nextSlide - 1 + totalSlides) % totalSlides
      } else {
        // При русі назад показуємо слайд, що на -2 позиції від поточного центрального
        sourceSlideIndex = (currentSlide - 2 + totalSlides) % totalSlides
      }

      // Вибираємо потрібний слайд
      let $sourceSlide = $(slick.$slides[sourceSlideIndex])
      let imgSrc = $sourceSlide.find('img').attr('src')

      // Виберемо контейнер і поточне зображення
      let $container = $('.team__items--single .team-item__in')

      // Створюємо обгортку для зображень з перевизначеним overflow
      if (!$container.find('.photo-container').length) {
        $container
          .find('.team-item__photo')
          .wrap(
            '<div class="photo-container" style="position: relative; overflow: hidden; width: 100%; height: 100%;"></div>'
          )
      }
      let $photoContainer = $container.find('.photo-container')

      // Поточне зображення
      let $currentImage = $photoContainer.find('.team-item__photo')

      // Створюємо нове зображення
      let $newImage = $(
        '<img class="team-item__photo new-slide" src="' + imgSrc + '">'
      )

      // Встановлюємо початкові стилі для обох зображень
      $newImage.css({
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transform: isNext
          ? 'translate3d(100%, 0, 0)'
          : 'translate3d(-100%, 0, 0)',
        transition: 'none',
      })

      // Впевнимось, що поточне зображення має правильні стилі
      $currentImage.css({
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transform: 'translate3d(0, 0, 0)',
        transition: 'none',
      })

      // Додаємо нове зображення
      $photoContainer.append($newImage)

      // Змушуємо браузер застосувати ці стилі перед анімацією
      $newImage[0].offsetHeight // Trigger reflow

      // Запускаємо анімацію після короткої затримки
      requestAnimationFrame(function () {
        $currentImage.css({
          transition: 'transform 400ms cubic-bezier(0.25, 1, 0.5, 1)',
          transform: isNext
            ? 'translate3d(-100%, 0, 0)'
            : 'translate3d(100%, 0, 0)',
        })

        $newImage.css({
          transition: 'transform 400ms cubic-bezier(0.25, 1, 0.5, 1)',
          transform: 'translate3d(0, 0, 0)',
        })
      })

      // Прибираємо старе зображення і стилі після завершення анімації
      setTimeout(function () {
        $currentImage.remove()
        $newImage.removeClass('new-slide')
      }, 450) // Трохи довше, ніж тривалість анімації
    }
  )

  // Mission

  // // Обидві анімації запускаються одночасно використовуючи position параметр
  // tl.to(
  //   '.mission-counter__items',
  //   {
  //     y: `-${missionCounterItemHeight * 2}px`, // Подвоюємо відстань для двох кроків
  //     opacity: 1,
  //     duration: 1,
  //     ease: 'none',
  //   },
  //   0
  // ) // 0 означає початок таймлайну

  // tl.to(
  //   '.mission-content__items',
  //   {
  //     y: `-${missionContentItemHeight * 2}px`, // Подвоюємо відстань для двох кроків
  //     opacity: 1,
  //     duration: 1,
  //     ease: 'none',
  //   },
  //   0
  // ) // 0 означає, що ця анімація також почнеться на початку таймлайну

  // Якщо потрібно розділити анімацію на два окремих кроки з паузою,
  // можна використати наступний підхід:

  if ($(window).width() > 1024 && $('.mission').length) {
    const missionCounterItems = document.querySelector(
      '.mission-counter__items'
    )
    const missionContentItems = document.querySelector(
      '.mission-content__items'
    )
    const missionCounterItemHeight = document.querySelector(
      '.mission-counter__item'
    ).offsetHeight
    const missionContentItemHeight = document.querySelector(
      '.mission-content__item'
    ).offsetHeight

    // Масив номерів у лічильнику (тепер 4 елементи)
    const counterNumbers = [
      '.mission-counter__item:nth-child(1) .mission-counter__number',
      '.mission-counter__item:nth-child(2) .mission-counter__number',
      '.mission-counter__item:nth-child(3) .mission-counter__number',
      '.mission-counter__item:nth-child(4) .mission-counter__number',
    ]

    // Визначаємо константи для повторюваних значень
    const ANIMATION_DURATION = 0.5
    const EASE_TYPE = 'none'
    const ACTIVE_COLOR = 'rgba(255, 255, 255, 1)'
    const INACTIVE_COLOR = 'rgba(255, 255, 255, 0.1)'

    // Налаштування таймлайну
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.mission',
        start: 'top top',
        end: '+=100%',
        scrub: true,
        // markers: true,
        pin: true,
      },
    })

    // Перша фаза анімації (позиція 0)
    tl.to(
      missionCounterItems,
      {
        y: `-${missionCounterItemHeight}px`,
        opacity: 1,
        duration: ANIMATION_DURATION,
        ease: EASE_TYPE,
      },
      0
    )
      .to(
        counterNumbers[0],
        {
          color: INACTIVE_COLOR,
          duration: ANIMATION_DURATION,
          ease: EASE_TYPE,
        },
        0
      )
      .to(
        counterNumbers[1],
        {
          color: ACTIVE_COLOR,
          duration: ANIMATION_DURATION,
          ease: EASE_TYPE,
        },
        0
      )
      .to(
        missionContentItems,
        {
          y: `-${missionContentItemHeight}px`,
          opacity: 1,
          duration: ANIMATION_DURATION,
          ease: EASE_TYPE,
        },
        0
      )

    // Друга фаза анімації (позиція 1)
    tl.to(
      missionCounterItems,
      {
        y: `-${missionCounterItemHeight * 2}px`,
        duration: ANIMATION_DURATION,
        ease: EASE_TYPE,
      },
      1
    )
      .to(
        missionContentItems,
        {
          y: `-${missionContentItemHeight * 2}px`,
          duration: ANIMATION_DURATION,
          ease: EASE_TYPE,
        },
        1
      )
      .to(
        counterNumbers[1],
        {
          color: INACTIVE_COLOR,
          duration: ANIMATION_DURATION,
          ease: EASE_TYPE,
        },
        1
      )
      .to(
        counterNumbers[2],
        {
          color: ACTIVE_COLOR,
          duration: ANIMATION_DURATION,
          ease: EASE_TYPE,
        },
        1
      )

    // Третя фаза анімації (позиція 2)
    tl.to(
      missionCounterItems,
      {
        y: `-${missionCounterItemHeight * 3}px`,
        duration: ANIMATION_DURATION,
        ease: EASE_TYPE,
      },
      2
    )
      .to(
        missionContentItems,
        {
          y: `-${missionContentItemHeight * 3}px`,
          duration: ANIMATION_DURATION,
          ease: EASE_TYPE,
        },
        2
      )
      .to(
        counterNumbers[2],
        {
          color: INACTIVE_COLOR,
          duration: ANIMATION_DURATION,
          ease: EASE_TYPE,
        },
        2
      )
      .to(
        counterNumbers[3],
        {
          color: ACTIVE_COLOR,
          duration: ANIMATION_DURATION,
          ease: EASE_TYPE,
        },
        2
      )
  }

  // Values
  if ($(window).width() > 1024 && $('.values').length) {
    const valuesItems = document.querySelectorAll('.values-item')
    const valuesSection = document.querySelector('.values')
    const valuesItemHeight = document.querySelector('.values-item').offsetHeight

    const baseOpacity = 0.1 // Початкова прозорість для першого елемента
    const opacityStep = 0.1 // Наскільки збільшується прозорість з кожним елементом

    // Створюємо таймлайн
    const valuesTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: valuesSection,
        start: 'top top',
        end: '+=100%',
        scrub: true,
        // markers: true,
        pin: true,
      },
    })

    // Перебираємо всі елементи
    valuesItems.forEach((item, index) => {
      valuesTimeline.to(
        item,
        {
          y: `-${40 - index * 10}px`,
          opacity: 1,
          backgroundColor: `rgba(255, 255, 255, 1)`,
          duration: 0.5,
          ease: 'none',
          onComplete: () => {
            // Отримуємо попередній елемент (при скролі вниз)
            const prevItem = valuesItems[index - 1]
            if (prevItem) {
              gsap.to(prevItem, {
                backgroundColor: `rgba(255, 255, 255, ${
                  baseOpacity + index * opacityStep
                })`,
                duration: 0.5,
              })
            }
          },
          onReverseComplete: () => {
            // Отримуємо наступний елемент (при скролі вгору)
            const nextItem = valuesItems[index - 1]
            if (nextItem) {
              gsap.to(nextItem, {
                backgroundColor: `rgba(255, 255, 255, 1)`, // Повертаємо білий фон
                duration: 0.5,
              })
            }
          },
        },
        index
      )
    })
  }

  // History
  if ($(window).width() > 1024) {
    const historyItems = document.querySelectorAll('.history-item')
    const yearLinks = document.querySelectorAll('.history-years__link')
    const progressBar = document.querySelector('.history-progress__bar')

    const progressBarHeight = 10 // Висота у відсотках (10%)

    // Початково ховаємо всі елементи (крім першого)
    gsap.set(historyItems, {
      display: 'none',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
    })
    gsap.set(historyItems[0], { display: 'block' }) // Перший елемент завжди показаний
    gsap.set(progressBar, { top: '0%' }) // Прогрес-бар на старті

    // Функція для правильного розрахунку `top` для прогрес-бару
    const calculateTopPosition = (index) => {
      const step = (100 - progressBarHeight) / (historyItems.length - 1)
      return `${index * step}%`
    }

    // timeline
    const historyTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: '.history',
        start: 'top top',
        end: `+=${historyItems.length * 100}vh`, // Синхронізуємо з кількістю секцій
        scrub: true,
        // markers: true,
        pin: true,
        pinSpacing: false,
      },
    })

    // Перебираємо всі елементи історії
    historyItems.forEach((item, index) => {
      historyTimeline.to(
        {},
        {
          duration: 0.5,
          onComplete: () => {
            // Ховаємо попередній елемент (при скролі вниз), крім першого
            const prevItem = historyItems[index - 1]
            if (prevItem && index > 0) {
              gsap.set(prevItem, { display: 'none' })
            }

            // Показуємо поточний елемент
            gsap.set(item, { display: 'block' })

            // **Оновлення прогрес-бару (переміщуємо вниз по `top`)**
            gsap.to(progressBar, {
              top: calculateTopPosition(index),
              duration: 0.2,
              ease: 'power1.out',
            })
          },
          onReverseComplete: () => {
            // Ховаємо поточний елемент (але не перший)
            if (index > 0) {
              gsap.set(item, { display: 'none' })
            }

            // Показуємо попередній елемент (при скролі вгору), крім першого
            const prevItem = historyItems[index - 1]
            if (prevItem && index > 0) {
              gsap.set(prevItem, { display: 'block' })
            }

            // **Оновлення прогрес-бару при скролі вгору**
            gsap.to(progressBar, {
              top: calculateTopPosition(Math.max(index - 1, 0)), // Не даємо піти в -1
              duration: 0.2,
              ease: 'power1.out',
            })
          },
        },
        index
      )
    })

    // Перебираємо всі посилання
    yearLinks.forEach((link, index) => {
      historyTimeline.to(
        {},
        {
          duration: 0.3,
          onComplete: () => {
            $('.history-years__link').removeClass('is-active')
            link.classList.add('is-active')

            gsap.to(link, {
              fontSize: '5.8rem',
              color: '#00AABB',
              duration: 0.3,
            })

            yearLinks.forEach((otherLink) => {
              if (otherLink !== link) {
                gsap.to(otherLink, {
                  fontSize: '3.6rem',
                  color: 'rgba(0, 0, 0, 0.1)',
                  duration: 0.3,
                })
              }
            })
          },
          onReverseComplete: () => {
            $('.history-years__link').removeClass('is-active')
            link.classList.add('is-active')

            gsap.to(link, {
              fontSize: '5.8rem',
              color: '#00AABB',
              duration: 0.3,
            })

            yearLinks.forEach((otherLink) => {
              if (otherLink !== link) {
                gsap.to(otherLink, {
                  fontSize: '3.6rem',
                  color: 'rgba(0, 0, 0, 0.1)',
                  duration: 0.3,
                })
              }
            })
          },
        },
        index
      )
    })
  }
})

window.addEventListener('load', () => {
  ScrollTrigger.refresh()
})
